import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  position: relative;

  @media screen and (max-width: 450px) {
    width: 100%;
    padding: 20px;
  }
`;

export const Close = styled.span`
  display: inline-flex;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  z-index: 9999;
  transition: all 0.15s ease;
  border-radius: 9999px;
  padding: 6px;
  color: #111827;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f3f4f6;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Title = styled.div`
  display: flex;
  position: relative;
  color: #111827;
  margin-bottom: ${(props) => props.marginBottom || "10px"};
  font-weight: 600;
  font-size: ${(props) => props.fontSize || "18px"};
  line-height: 1.25;
  align-items: center;
  padding-right: 40px;
`;

export const ContainerLegend = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px;
  border-radius: 8px;
  background-color: #f8f9fa;
  margin-bottom: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 100px;
  padding: 25px;
  border-radius: 50%;
  background-color: #f4e6fb;

  @media screen and (max-width: 450px) {
    width: 300px;
  }
`;

export const BoxEmails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  margin-bottom: 0;
  gap: 6px;
  max-height: 480px;
  overflow: auto;
`;

export const BoxTemplate = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 180px;
  padding: 16px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
`;

export const BoxTemplateContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  border-radius: 6px;
  background-color: transparent;
`;
